 

<template>
    <div class="px-6 flex justify-between items-center">
       <router-link  to="/" class="flex justify-center items-center bg-g300 w-12 h-12 rounded-full text-2xl !leading-none text-white">
          <i class="ph ph-caret-left"></i>
        </router-link>
        <div class="flex-1 flex justify-center items-center pr-12">
          <p class="text-2xl font-semibold">Absensi</p>
        </div>
      </div>
      <div class="pt-8 flex justify-center items-center flex-col">
        
        <p class="text-sm font-semibold pt-3">
          {{ status }}    {{ text1 }} 
        </p>
        
      </div>
      <div v-if="!loc" class="px-6 relative z-20" >
        <pulse-loader :loading="loading" :color="color" :size="size" style="position: absolute; top: 50%;right: 45%;"></pulse-loader>
         
        <img src="../../public/asset/map.jpg" style="width: 100%;" />
        <p class="text-sm font-semibold pt-3 flex justify-center items-center flex-col">{{text1.value}}</p>
        <p class="text-sm   pt-3 flex justify-center items-center flex-col">ijinkan aplikasi untuk mengakses lokasi</p>
      </div>
      <div v-else class="page">
        
         
        <CameraView ref="cameraRef" :enableLiveness="true" @livenessPassed="doAbsensi" />

        <div style="z-index: 9999;margin-top: 10px;">
        
         
        </div>
        
      </div>
      


  <transition name="fade" appear>
    <div class="modal-overlay" 
         v-if="showModal" 
         @click="showModal = false"></div>
  </transition>
  <transition name="pop" appear>
    <div class="modal" 
         role="dialog" 
         v-if="showModal"
         >
      <h1>{{ status }}</h1>
      
      <button  v-if="sts"    @click="showModal = false" class="flex-1 py-3 bg-g300 text-white text-center rounded-xl font-medium border border-g300 px-6" >Check In</button>

    </div>
  </transition>

</template>



<script setup>
import { ref,onMounted,onBeforeUnmount } from 'vue'
import CameraView from '../components/CameraView.vue'
import { useRouter } from "vue-router";
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import { useGeolocation } from '@vueuse/core'



const status = ref(" ")
const loc = ref(false)
const loading = ref(true)
var showModal = ref(false)
let sts = ref(false)
const router = useRouter();
let  text1 = ref("Lokasi Belum Tepat")
//let aktif = ref(true)

const latlng = ref()
const { coords } = useGeolocation()

const lat = coords
let ceklok = null

function getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) {
  const R = 6371 // Radius bumi (km)
  const dLat = (lat2 - lat1) * Math.PI / 180
  const dLon = (lon2 - lon1) * Math.PI / 180
  const a =
    Math.sin(dLat/2) * Math.sin(dLat/2) +
    Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
    Math.sin(dLon/2) * Math.sin(dLon/2)
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a))
  const d = R * c
  return d // hasil dalam KM
} 

onMounted(async () => {

    const token = localStorage.getItem("token");

    const res = await fetch("https://kiyanrahayu.my.id/api2/status",{
      headers: {         
        "Authorization": "Bearer " + token,
         "Accept": "application/json"
       }
    })

     if(res.ok){
        const data = await res.json() 
        latlng.value = data.latlng
         ceklok = setInterval(async () => {
            cekloc()
         },1000)
     }


})

 function doAbsensi(inputDescriptor) {
  //  showModal.value = true
     sts.value = inputDescriptor.sts
   if(sts.value){
    chekin();
   }else{
      showModal.value = true
      status.value = "Absensi  " + inputDescriptor.msg
   }
     
 }

 async function chekin(){
    const token = localStorage.getItem("token");
    const formData = new FormData()
    formData.append("cmd","absen")
    const res = await fetch("https://kiyanrahayu.my.id/api2", {
      headers: {         
        "Authorization": "Bearer " + token,
         "Accept": "application/json"
       },
       method: "POST",
       body: formData
    })

    if (res.ok) {
       // showModal.value = true
        status.value = "Absensi  Sukses" 
        router.push("/cekin");

    }else{
        showModal.value = true
        status.value = "Absen GAgal"
    }


 }

 onBeforeUnmount(() => {
  if (ceklok) clearInterval(ceklok) 
})

function cekloc(){
  //  coords.latitude }}  LAng : {{   coords.longitude
//  const office = { lat: -8.6678017, lng: 115.2047601 }
    const office = latlng.value
  console.log(  " lat : " +  lat.value.latitude )
  const distance = getDistanceFromLatLonInKm(office.lat,office.lng,lat.value.latitude, lat.value.longitude)

  const radius = 0.05

    console.log(distance)

  if (distance <= radius) {
    console.log("✅ User berada dalam radius")
    //aktif = false
    loc.value = true;
    text1 = "Absen ready"
  } else {
    console.log("❌ User di luar area")
    //  aktif = true
      loc.value = false;
     text1 = "Lokasi Belum Tepat"
  }
}

// async function doAbsensi2(imageDataUrl) {
//   const blob = await (await fetch(imageDataUrl)).blob()
//   const formData = new FormData()
//   formData.append("file", blob, "face.png")

//   const res = await fetch("https://192.168.1.7:8443/verify", {
//     method: "POST",
//     body: formData
//   })
//   if (res.ok) {
//     const data = await res.json()
//     if (data.matched) {
//       status.value = "Absensi berhasil untuk " + data.name
//       // Catat absensi
//       await fetch("https://192.168.1.7:8443/attendance/log", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ employee_id: data.employee_id })
//       })
//     } else {
//       status.value = "Wajah tidak dikenali!"
//     }
//   } else {
//     status.value = "Server error!"
//   }
// }
</script>

<style scoped>
.page { padding: 20px; }

.modal {
  position: absolute;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  text-align: center;
  width: fit-content;
  height: fit-content;
  max-width: 22em;
  padding: 2rem;
  border-radius: 1rem;
  box-shadow: 0 5px 5px rgba(0, 0, 0, 0.2);
  background: #FFF;
  z-index: 999;
  transform: none;
}
.modal h1 {
  margin: 0 0 1rem;
}

.modal-overlay {
  content: '';
  position: absolute;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 998;
  background: #2c3e50;
  opacity: 0.6;
  cursor: pointer;
}

/* ---------------------------------- */
.fade-enter-active,
.fade-leave-active {
  transition: opacity .4s linear;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.pop-enter-active,
.pop-leave-active {
  transition: transform 0.4s cubic-bezier(0.5, 0, 0.5, 1), opacity 0.4s linear;
}

.pop-enter,
.pop-leave-to {
  opacity: 0;
  transform: scale(0.3) translateY(-50%);
}

</style>
